const messagesCn = {
  about: '关于',
  acceptanceCriteria: '验收标准',
  accomplishments: '成就',
  actions: '操作',
  activity: '活动',
  activatePod: '激活POD',
  activePods: '活跃POD',
  add: '添加',
  addBlocker: '添加阻塞信息',
  addingCandidateWait: '正在添加候选人，请稍候...',
  addPortfolio: '添加作品集',
  addStakeholder: '添加利益相关者',
  addVideoUpdate: '添加视频更新',
  findAgents: '查找代理',
  all: '全部',
  allReporters: '所有报告者',
  allRepoCheckins: '所有代码库签入',
  approve: '批准',
  approved: '已批准',
  approvalRequests: '审批请求',
  approvedPRCount: '已批准PR数量',
  assignedItems: '已分配项目',
  availability: '可用性',
  availableDate: '可用日期',
  backToPods: '返回我的POD',
  basicInformation: '基本信息',
  blocker: '阻塞',
  blockerDetails: '阻塞详情',
  blockers: '阻塞问题',
  board: '看板',
  browseTalent: '浏览人才',
  bugs: '缺陷',
  calendlyUrl: 'Calendly链接',
  cancel: '取消',
  candidates: '候选人',
  categories: '类别',
  certifications: '认证',
  certificationUrl: '认证链接',
  checkBoxBlocker: '如果这是阻塞问题请勾选此框',
  ciCdPipeline: 'CI/CD流水线',
  clear: '清除',
  client: '客户',
  clickHereUploadVideoClip: '点击这里上传视频片段！',
  cloudCost: '云成本',
  code: '代码行数',
  codeSmells: '代码异味',
  commentHere: '在此评论...',
  category: '类别',
  comments: '评论',
  companyName: '公司名称',
  copied: '已复制！',
  copyright: '版权所有 © 2025-至今 Brilli Global, Inc. 保留所有权利。',
  copyToClipboard: '复制到剪贴板',
  cost: '成本',
  costDetails: '成本详情',
  country: '国家',
  create: '创建',
  createArt: '创建ART',
  createGig: '创建解决方案',
  createPod: '创建POD',
  createProfile: '创建档案',
  createProfileOpportunity: '在我们的人才数据库中创建您的档案，以便被包含在各种远程工作机会中。',
  createTask: '创建任务',
  createYourOwnPod: '创建您自己的POD并浏览项目',
  creatingProfile: '正在创建档案',
  currency: '货币',
  currentlyAvailable: '当前可用',
  currentWeek: '本周',
  dashboard: '仪表板',
  date: '日期',
  dateRangeFilter: '日期范围筛选',
  deactivatePod: '停用POD',
  deactivateToUpdate: '停用POD以更新POD！',
  defects: '缺陷',
  delete: '删除',
  deletePod: '删除POD',
  description: '描述',
  detailsForGitHubRepo: 'GitHub仓库详情',
  done: '关闭',
  Done: '完成',
  doraMetrics: 'Dora指标',
  dueDate: '截止日期',
  duplicatedLinesDensity: '重复行密度',
  edit: '编辑',
  education: '教育',
  educationAndCertifications: '教育与认证',
  email: '电子邮箱',
  podTime: 'POD时间',
  createHub: '创建中心',
  createSolution: '创建解决方案',
  podVelocity: 'POD速度',
  podBlockers: 'POD阻塞',
  podsync: 'POD同步',
  endDate: '结束日期',
  enterEmailToInvite: '输入邮箱地址邀请',
  enterPodMission: '输入POD使命',
  enterPodName: '输入POD名称',
  enterStoryDescription: '输入故事描述',
  executionDate: '执行日期',
  executionID: '执行ID',
  externalPod: '外部POD',
  fileNameNoSpaces: '文件名不应包含空格',
  fileUpload: '文件上传',
  findBestFreelancers: '找到最好的自由职业者或人才团队，以更快的速度完成您的项目！',
  findBestPod: '找到与您的经验/技能匹配的POD',
  findPods: '查找POD',
  findTalent: '查找人才',
  findYourBestTalentPod: '找到您最好的人才POD',
  firstName: '名',
  focus: '重点',
  gitHubRepo: 'GitHub仓库',
  gitHubUsername: 'GitHub用户名',
  github: 'Github',
  githubSummary: 'GitHub摘要',
  githubUrl: 'Github链接',
  githubUser: 'GitHub用户',
  giveRating: '给出评分',
  globalWorkPlatform: '全球工作平台',
  home: '首页',
  hoursPerWeek: '每周小时数',
  inactivePod: '不活跃POD',
  individual: '个人',
  industry: '行业',
  inProgress: '进行中',
  institute: '机构',
  internalPod: '内部POD',
  invite: '邀请',
  invoices: '发票',
  issueKey: '问题编号',
  issueStatus: '问题状态',
  issueSummary: '问题摘要',
  jiraIssue: 'Jira问题',
  jiraIssues: 'Jira问题',
  jiraItem: 'Jira项目',
  jiraTimeDetails: '时间日志',
  jiraUsername: 'Jira用户名',
  keepDoing: '继续做',
  keyword: '关键词',
  languageSpoken: '语言',
  lastName: '姓',
  latestSprintVelocity: '最新冲刺速度',
  linkedIn: 'LinkedIn',
  linkedInUrl: 'LinkedIn链接',
  linesOfCodeByDay: '每日代码行数',
  listOfTalents: '人才列表',
  loading: '加载中',
  loadingAcceptanceCriteria: '正在加载验收标准',
  loadingStoryDescription: '正在加载故事描述',
  loadingTestCases: '正在加载测试用例',
  logOut: '退出登录',
  login: '登录',
  manage: '管理',
  manageActivities: '管理您的每日POD活动和更新',
  manageProfile: '管理档案',
  manageProfileHere: '在此管理您的档案',
  managePod: '管理POD',
  managePods: '管理您的所有POD及其活动',
  markComplete: '标记完成',
  middleName: '中间名',
  myPods: '我的POD',
  myTasks: '我的任务',
  name: '名称',
  ncloc: 'Ncloc',
  newActivityUpdate: '新活动更新',
  next: '下一个',
  noArtOptionsAvailable: '没有可用的ART选项',
  noBlockers: '没有阻塞问题',
  noCandidates: '没有添加候选人',
  noCandidatesAddedToPod: '没有向POD添加候选人！',
  noCandidateReviews: '没有候选人评价。',
  noData: '无数据',
  noDataAvailable: '无可用数据',
  noExperience: '无经验',
  noMatchingPods: '没有匹配的POD可用',
  noNotifications: '没有通知',
  noPodActivity: '您没有任何POD活动',
  noPods: '您没有任何POD',
  noPodTasks: '您没有任何POD任务',
  noReviews: '没有评价。',
  noStakeholders: '此POD没有利益相关者',
  noSubscription: '您没有任何订阅计划',
  noVideoAvailable: '无可用视频',
  notifications: '通知接收者',
  otherInformation: '其他信息',
  pending: '待处理',
  pendingPods: '待处理POD',
  phoneNumber: '电话号码',
  pipelineExecutionDetails: '流水线执行详情',
  pipelineName: '流水线名称',
  pipelineVersion: '流水线版本',
  pleaseEnterStoryDescription: '请输入故事描述并点击提交',
  POD: 'POD',
  podActivities: 'POD活动',
  podActivity: 'POD活动',
  podAnalytics: 'POD分析',
  podAssist: 'POD助手',
  podAutomation: 'POD自动化',
  podBoard: 'POD看板',
  podCategories: 'POD类别',
  podDescription: 'POD描述',
  podExperience: 'POD经验',
  podFeedback: 'POD反馈',
  podMetrics: 'POD指标',
  podName: 'POD名称',
  podQuery: 'POD查询',
  podRequests: 'POD请求',
  podRetro: 'POD回顾',
  podSize: 'POD规模',
  podTasks: 'POD任务',
  podTaskDescription: 'POD任务描述',
  podTaskDueDate: 'POD任务截止日期',
  podTaskName: 'POD任务名称',
  podTaskOwner: 'POD任务负责人',
  podTaskStatus: 'POD任务状态',
  podTechStack: 'POD技术栈',
  podTeamMember: 'POD团队成员',
  podType: 'POD类型',
  portfolio: '作品集',
  portfolioUrl: '作品集链接',
  post: '发布',
  postActivity: '发布活动',
  postPodActivity: '发布POD活动',
  postRequirement: '发布需求',
  posting: '正在发布...',
  postedDate: '发布日期',
  postedRequirements: '您发布的POD需求',
  positionName: '职位名称',
  prCount: 'PR数量',
  preferredWorkHours: '首选工作时间',
  prev: '上一个',
  previousPods: '之前的POD',
  previousWeek: '上周',
  primarySkill: '主要技能',
  privacyPolicy: '隐私政策',
  privatePods: '私有POD',
  prSummary: 'PR摘要',
  projectKey: '项目密钥',
  profileLink: '档案链接',
  profileVisibility: '档案可见性',
  public: '公开',
  qualification: '资格',
  ratePerHour: '每小时费率',
  ratePerMonth: '每月费率',
  recentSearches: '最近搜索',
  region: '地区',
  register: '注册',
  resetPassword: '重置密码',
  restricted: '限制',
  retro: '回顾',
  review: '评价和评分',
  revisionSummary: '修订摘要',
  revisionURL: '修订链接',
  resume: '简历',
  resumeLink: '查看简历',
  rowsPerPage: '每页行数',
  save: '保存',
  search: '搜索',
  searchProjects: '搜索项目',
  secondarySkill: '次要技能',
  select: '选择',
  selectArtName: '选择ART名称',
  selectAUser: '选择用户',
  selectFilter: '选择筛选器',
  applyFilters: '应用筛选器',
  selectItemsPerPage: '选择每页项目数',
  selectJiraIssues: '选择Jira问题',
  selectPod: '选择POD',
  selectPodTeamMember: '选择POD团队成员',
  selectPods: '选择POD',
  services: '服务',
  setting: '设置',
  shareableLink: '可分享链接',
  signUpToGetStarted: '"注册"开始使用！',
  getStarted: '开始',
  skills: '技能',
  skillsAndExpertise: '技能与专长',
  sonarqubeprojectkey: 'Sonarqube项目密钥',
  sonarqubeStats: 'Sonarqube统计',
  specialization: '专业化',
  sprintVelocity: '冲刺速度',
  sprint: '冲刺',
  spotsLeft: '剩余名额',
  startDate: '开始日期',
  startDoing: '开始做',
  status: '状态',
  stopDoing: '停止做',
  storyDescription: '故事描述',
  stories: '故事',
  submit: '提交',
  submittedDate: '提交日期',
  submittedPRCount: '已提交PR数量',
  subscription: '订阅',
  talentApprovalRequests: '人才审批请求',
  talentCode: '人才代码',
  taskForm: '任务表单',
  taskManager: '任务管理器',
  taskName: '任务名称',
  tasks: '任务',
  teamMember: '团队成员',
  techStack: '技术栈',
  termsOfService: '服务条款',
  testCases: '测试用例',
  time: '时间',
  timeLog: '时间日志',
  timeSubmit: '时间提交',
  timeZone: '时区',
  toDo: '待办',
  todaysFocus: '今日重点',
  totalLinesChangedLastWeek: '上周总变更行数',
  totalLinesChangedThisWeek: '本周总变更行数',
  totalPRCount: '总PR数量',
  university: '大学',
  update: '更新',
  updateProfileHere: '在此更新您的档案',
  updatingVisibility: '正在更新可见性...',
  upload: '上传',
  userStory: '用户故事',
  validFrom: '有效期自',
  validTill: '有效期至',
  talentexplorer: '人才探索器',
  interviewrequests: '面试请求',
  videoUrl: '视频链接',
  view: '查看',
  viewActivities: '查看活动',
  viewDetails: '查看详情',
  viewPodActivities: '查看POD活动',
  viewPodDetails: '查看POD详情',
  viewProfile: '查看档案',
  viewTasks: '查看任务',
  viewTimeEntries: '查看时间条目',
  viewVideo: '查看视频',
  visitFindTalent: '请访问"查找人才"页面，向您的POD添加有才华的个人。',
  vulnerabilities: '漏洞',
  welcome: '欢迎来到Artemy.ai！',
  workExperience: '工作经验',
  yourPod: '您的POD',
  yourPods: '您的POD',
  yourPostedPodActivity: '您发布的POD活动',
  
  findTickets: '查找工单',
  epics: '史诗',
  date: '日期',
  talent: '人才',
  focus: '重点',
  startDate: '开始日期',
  endDate: '结束日期',
  status: '状态',
  allStatus: '所有状态',
  blocked: '已阻塞',
  onTrack: '正常进行',
  activityDetails: '活动详情',
  jiraIssues: 'Jira问题',
  todaysFocus: '今日重点',
  accomplishments: '成就',
  blockers: '阻塞问题',
  videoUpdate: '视频更新',
  comments: '评论',
  addBlockerInformation: '添加阻塞信息',
  blockerDetails: '阻塞详情',
  cancel: '取消',
  saveChanges: '保存更改',
  selectJiraIssues: '选择Jira问题',
  design: '设计',
  development: '开发',
  testing: '测试',
  bugFix: '缺陷修复',
  documentation: '文档',
  myPods: '我的POD',
  postRetro: '发布回顾',
  newRetro: '新回顾',
  startDoing: '开始做',
  stopDoing: '停止做',
  keepDoing: '继续做',
  viewRetros: '查看回顾',
  podRetroFeedback: 'POD回顾反馈',
  selectSprint: '选择冲刺',
  thisTaskIsBlocker: '此任务是阻塞问题',
  category: '类别',
  taskCreatedSuccessfully: '任务创建成功！',
  taskManagement: '任务管理',
  searchJiraIssues: '搜索JIRA问题...',
  creatingTask: '正在创建任务...',
  createTask: '创建任务',
  description: '描述',
  dueDate: '截止日期',
  commentsHistory: '评论历史',
  noCommentsYet: '暂无评论',
  writeAComment: '写评论...',
  all: '全部',
  blockerStatus: '阻塞状态',
  blockedTasks: '被阻塞任务',
  unblockedTasks: '未阻塞任务',
  clearDateRange: '清除日期范围',
  selectDateRange: '选择日期范围',
  showAllTime: '显示所有时间',
  noTasksFound: '未找到任务',
  noLinkedIssues: '无关联问题',
  timeSheet: '时间表',
  podTimeSheet: 'POD时间表',
  userStory: '用户故事',
  hours: '小时',
  minutes: '分钟',
  actions: '操作',
  submitTimeEntries: '提交时间条目',
  selectCategory: '选择类别',
  selectStory: '选择故事',
  addRow: '添加行',
  podSelection: 'POD选择',
  selectPodToView: '选择POD以查看冲刺和人才筛选器',
  toDo: '待办',
  podAssist: 'POD助手',
  inProgress: '进行中',
  done: '完成',
  selectPodsRequired: '选择POD（必需）',
  enterStoryDescription: '输入故事描述',
  podSyncSummaries: 'POD同步摘要',
  enterMeetingUrl: '输入会议链接...',
  searchInSummaries: '在摘要中搜索...',
  dateAndTime: '日期和时间',
  quickTimeRange: '快速时间范围',
  sortByDate: '按日期排序',
  selectTalents: '选择人才',
  filterBySpecificCandidates: '按特定候选人筛选（可选）',
  talentSelection: '人才选择',
  priority: '优先级',
  addComment: '添加评论',
  taskDetails: '任务详情',
  summary: '摘要',
  addMeeting: '添加会议',

  podAutomation: 'POD自动化',
  uploading: '上传中...',
  uploadFile: '上传文件',
  send: '发送',
  submitting: '提交中...',
  enterYourQuestionHere: '在此输入您的问题',
  submitTheResults: '提交结果',
  export: '导出',
  podInsights: 'POD洞察',
  askQuestionsAboutYourPod: '询问关于您的POD活动、团队成员等的问题',
  welcomeToPodInsights: '欢迎来到POD洞察！',
  startByAskingQuestionsLike: '开始询问如下问题',
  showAllPodActivitiesThatHadBlockers: '显示所有有阻塞问题的POD活动',
  listAllCandidatesAndTheirPods: '列出所有候选人及其POD',
  showStakeholdersFromIndia: '显示来自印度的利益相关者',
  askAnythingAboutYourPods: '询问关于您的POD、团队成员、活动的任何问题...',
  sending: '发送中...',
  analyzingYourQuestion: '正在分析您的问题...',
  pipelineCICD: '流水线CI/CD',
  tickets: '工单',
  metricName: '指标名称',
  metricValue: '指标值',
  commentsHistory: '评论历史',
  noCommentsYet: '暂无评论',
  writeAComment: '写评论...',
  solutionManagement: '解决方案管理',
  searchSolutions: '搜索解决方案...',
  refresh: '刷新',
  createNewSolution: '创建新解决方案',
  solutionName: '解决方案名称',
  solutionDescription: '解决方案描述',
  updateSolution: '更新解决方案',
  createSolution: '创建解决方案',
  confirmSolutionDeletion: '您确定要删除解决方案吗',
  artManagement: 'ART管理',
  podManagement: 'POD管理',
  searchPods: '搜索POD...',
  viewPod: '查看POD',
  searchARTs: '搜索ART...',
  noARTsFound: '未找到ART。点击"创建新ART"按钮创建您的第一个ART。',
  createNewART: '创建新ART',
  selectGig: '选择项目',
  artName: 'ART名称',
  artDescription: 'ART描述',
  createART: '创建ART',
  confirmDeletion: '确认删除',
  confirmARTDeletion: '您确定要删除ART吗',
  primaryLanguage: '主要语言',
  selectSkills: '选择技能',
  timeZone: '时区',
  updateART: '更新ART',
  somethingWentWrong: '出了些问题',
  reloadPage: '重新加载页面',
  privatePods: '私有POD',
  activePods: '活跃POD',
  completedPods: '已完成POD',
  pendingPods: '待处理POD',
  loadingPods: '正在加载POD...',
  retry: '重试',
  noPodsFound: '未找到POD',
  createFirstPod: '创建您的第一个POD开始使用',
  previous: '上一个',
  showing: '显示',
  size: '大小',
  teamSize: '团队规模',
  activeMembers: '活跃成员',
  stakeholders: '利益相关者',
  podManagers: 'POD管理员',
  addManager: '添加管理员',
  podManager: 'POD管理员',
  noManagersAssignedYet: '尚未分配管理员',
  addManagersToHelpOversee: '添加管理员以帮助监督此POD',
  noStakeholdersYet: '尚无利益相关者',
  settings: '设置',
  deletePod: '删除POD',
  addPodManager: '添加POD管理员',
  selectManagerToInvite: '选择要邀请到此POD的管理员：',
  noManagersAvailableToInvite: '没有可邀请的管理员。',
  selectAManager: '选择管理员',
  selectedManager: '已选管理员',
  inviteManager: '邀请管理员',
  noTeamMembersYet: '尚无团队成员',
  startByInvitingMembers: '开始邀请成员到您的POD',
  inviteTeamMembers: '邀请团队成员',
  existingMembers: '现有成员',
  inviteByEmail: '通过邮箱邀请',
  searchByNameOrSkills: '按姓名或技能搜索...',
  optionalSelectUserToNotify: '可选：选择要通过Slack通知的用户',
  pleaseSelectPodToEnableFields: '请选择POD以启用其他字段',
  selectedCandidates: '已选候选人',
  selectCandidatesToInvite: '选择要邀请到此POD的候选人',
  availableCandidates: '可用候选人',
  inviteNewMembersByEmail: '通过邮箱邀请新成员',
  emailAddresses: '邮箱地址',
  enterEmailAddresses: '输入邮箱地址（用逗号分隔）',
  hidePodTeamMembers: '在查找POD部分隐藏此POD团队成员（当前可见）',
  technicalDetails: '技术详情',
  currentTeamSize: '当前团队规模',
  communicationDetails: '沟通详情',
  podReview: 'POD评价',
  rating: '评分',
  writeReview: '写评价',
  shareYourExperience: '分享您使用此POD的体验...',
  submitReview: '提交评价',
  viewPod: '查看POD',
  managePod: '管理POD',
  editPod: '编辑POD',
  skillsAndExperience: '技能与经验',
  reviews: '评价',
  documents: '文档',
  otherInfo: '其他信息',
  noWorkExperienceDataAvailable: '无工作经验数据',
  selectART: '选择ART',
  selectAnART: '选择ART',
  jiraConfiguration: 'Jira配置',
  jiraProjectKey: 'Jira项目密钥',
  jiraURL: 'Jira链接',
  jiraAdminEmail: 'Jira管理员邮箱',
  jiraAdminAPIToken: 'Jira管理员API令牌',
  jiraOpenStoryBugStatus: 'Jira开放故事/缺陷状态',
  jiraClosedStoryBugStatus: 'Jira已关闭故事/缺陷状态',
  gitHubConfiguration: 'GitHub配置',
  gitHubUsername: 'GitHub用户名',
  gitHubAPIToken: 'GitHub API令牌',
  gitHubRepositoryName: 'GitHub仓库名称',
  circleCIConfiguration: 'CircleCI配置',
  circleCIGitHubUsername: 'CircleCI GitHub用户名',
  circleCIGitHubRepository: 'CircleCI GitHub仓库',
  circleCIAPIToken: 'CircleCI API令牌',
  sonarQubeConfiguration: 'SonarQube配置',
  sonarQubeCloudURL: 'SonarQube云链接',
  sonarQubeAPIToken: 'SonarQube API令牌',
  awsConfiguration: 'AWS配置',
  awsAccessKeyID: 'AWS访问密钥ID',
  awsSecretAccessKey: 'AWS秘密访问密钥',
  awsRegion: 'AWS区域',
  bitBucketConfiguration: 'BitBucket配置',
  bitBucketUsername: 'BitBucket用户名',
  bitBucketAppPassword: 'BitBucket应用密码',
  bitBucketWorkspace: 'BitBucket工作空间',
  openAIConfiguration: 'OpenAI配置',
  openAIToken: 'OpenAI令牌',
  storyPointsCalculation: '故事点计算',
  uploadStoryPointsCalculationFile: '上传故事点计算文件',
  currentFile: '当前文件',
  notifications: '通知',
  markAllAsRead: '全部标为已读',
  tryAgain: '重试',
  noNotificationsToDisplay: '无通知显示',
  viewAllNotifications: '查看所有通知',
  enterMultipleEmailsSeparatedByCommas: '输入多个邮箱地址，用逗号分隔',
  addEmailAddressesToInvite: '添加邮箱地址以邀请新成员',
  emailInvitationGuidelines: '邮箱邀请指南',
  inviteesWillReceiveInstructions: '被邀请者将收到加入此POD的说明',
  theyWillNeedToCreateAccount: '如果他们还没有账户，需要创建一个账户',
  noCandidatesAvailable: '无可用候选人',
  sendEmailInvites: '发送邮箱邀请',

  processingDataAndGeneratingInsights: '正在处理数据并生成洞察',
  retroHistory: '回顾历史',
  filterByMember: '按成员筛选',
  podProductivity: 'POD生产力',
  totalTasks: '总任务数',
  completed: '已完成',
  clearFilters: '清除筛选器',
  totalActivities: '总活动数',
  pendingApproval: '待审批',
  sortBy: '排序方式',
  editSolution: '编辑解决方案',
  cannotDeleteAssociatedWithARTs: '无法删除 - 与ART关联',
  editART: '编辑ART',
  createdDate: '创建日期',
  podDetails: 'POD详情',
  currentARTProject: '当前ART/项目',
  artProject: 'ART/项目',
  selectAvailability: '选择可用性',
  selectSkill: '选择技能',
  selectTimezone: '选择时区',
  selectLocation: '选择位置',
  selectBudget: '选择预算',
  podMember: 'POD成员',
  addToPod: '添加到POD',
  talentDetails: '人才详情',
  reviewsFeedback: '评价与反馈',
  noEducationDataAvailable: '无教育数据',
  noCertificationDataAvailable: '无认证数据',
  clientReview: '客户评价',
  noReviewsAvailableYet: '暂无评价',
  noClientReviews: '此人才尚未收到任何客户评价',
  resumeAvailable: '简历可用',
  viewDownloadResume: '查看或下载候选人的简历',
  noResumeAvailable: '无简历',
  noResumeUploaded: '此人才尚未上传简历。',
  codingAssessment: '编程评估',
  assessmentAvailable: '评估可用',
  viewAssessmentResults: '查看候选人的编程评估结果',
  noAssessmentAvailable: '无评估可用',
  noAssessmentCompleted: '此人才尚未完成编程评估。',
  partnerCompanyDetails: '合作公司详情',
  companyIntroductionVideo: '公司介绍视频',
  videoNotSupported: '您的浏览器不支持视频标签。',
  location: '位置',
  noPodsMatchingCriteria: '没有找到符合您条件的POD',
  hirePod: '雇用POD',
  notificationHistory: '通知历史',
  filter: '筛选',
  allNotifications: '所有通知',
  markSelected: '标记选中',
  unread: '未读',
  noNotificationsFound: '未找到通知',
  searchNotifications: '搜索通知...',
   subscriptionManagement: '订阅管理',
  choosePlanPrompt: '选择最适合您需求的套餐，随着业务增长进行扩展',
  cancelSubscription: '取消订阅',
  choosePlan: '选择套餐',
  noPlansAvailable: '暂无可用套餐',
  noPlansHelpText: '请稍后查看或联系客服寻求帮助。',
  currentPlanDetails: '当前套餐详情',
  renewalDate: '续费日期',
  subscriptionId: '订阅ID',
  paymentMethod: '付款方式',
  cardHolder: '持卡人',
  expires: '到期时间',
  brand: '品牌',
  billingHistory: '账单历史',
  noInvoiceHistory: '暂无发票历史记录',
  needHelp: '需要帮助？',
  supportText: '如果您对我们的订阅套餐有任何疑问或需要帮助，我们的客服团队随时为您服务。',
  contactSupport: '联系客服',
  completeSubscription: '完成您的订阅',
  planDetails: '套餐详情',
  planName: '套餐名称',
  basePrice: '基础价格',
  numberOfUsers: '用户数量',
  billingCycle: '计费周期',
  orderSummary: '订单摘要',
  annualDiscount: '年度折扣',
  billingPeriod: '计费期间',
  tax: '税费',
  totalWithTax: '含税总计',
  annually: '每年',
  continue: '继续',
  subscriptionSuccessful: '订阅成功！',
  thankYouSubscribing: '感谢您订阅',
  subscriptionActivated: '您的订阅已成功激活。',
  goToDashboard: '前往控制台',
  addPaymentMethod: '添加付款方式',
  cardNumber: '卡号',
  cardholderName: '持卡人姓名',
  expiryMonth: '到期月份',
  expiryYear: '到期年份',
  postalCode: '邮政编码',
  addCard: '添加卡片',
  paymentChoice: '使用现有卡片或添加新卡片',
  existingCardText: '您已有一张尾号为',
  useExistingCardPrompt: '您想要用它来支付此订阅吗？',
  useExistingCard: '使用现有卡片',
  addNewCard: '添加新卡片',
  processing: '处理中...',
  subscriptionSuccessDetails: '成功！',
  accessAllFeatures: '您现在可以访问订阅套餐中包含的所有功能。',
  editCardDetails: '编辑卡片详情',
  managerInvite: '经理邀请',
  talentInvite: '人才邀请',
  invitePodManagers: '输入邮箱邀请Pod经理',
  enterEmail: '输入邮箱',
  invite: '邀请',
  yourInvoices: '您的发票',
  noInvoices: '您没有任何发票。',
  getCountIsseswithNoCritria: '获取没有验收标准的问题数量',
  amountDue: '应付金额',
  amountPaid: '已付金额',
  noActiveSubscription: '您没有活跃的订阅套餐。请点击"订阅"链接添加订阅。',
  noActiveSubscriptionStart: '您没有活跃的订阅套餐。请点击',
  subscribe: '订阅',
  noActiveSubscriptionEnd: '链接添加订阅。'
};

export default messagesCn;